var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { memo, useMemo, } from 'react';
import classNames from 'classnames/bind';
import { Text } from '../../text';
import { BUTTON_VARIANTS } from '../constants';
import styles from '../button-link.module.scss';
import { ButtonLoader } from './button-loader';
var cn = classNames.bind(styles);
var BLOCK_NAME = 'Button-link';
export var ButtonLinkView = memo(function (_a) {
    var _b, _c, _d, _e;
    var fullWidth = _a.fullWidth, isBreadcrumbs = _a.isBreadcrumbs, isDarkTheme = _a.isDarkTheme, isLoading = _a.isLoading, isPopUp = _a.isPopUp, isTextCenter = _a.isTextCenter, isUpperCase = _a.isUpperCase, LeftIcon = _a.leftIcon, onClick = _a.onClick, RightIcon = _a.rightIcon, routeName = _a.routeName, size = _a.size, Tag = _a.tagName, tagOptionalProps = _a.tagOptionalProps, _f = _a.text, text = _f === void 0 ? '' : _f, textSize = _a.textSize, variant = _a.variant, buttonRef = _a.buttonRef, notFullWidthOnMobile = _a.notFullWidthOnMobile, onMouseOver = _a.onMouseOver, onFocus = _a.onFocus, textColor = _a.textColor, isTextLeft = _a.isTextLeft, textWhiteSpace = _a.textWhiteSpace, textRef = _a.textRef, onBlur = _a.onBlur;
    var isLink = useMemo(function () { return variant === BUTTON_VARIANTS.link; }, [variant]);
    var isOnlyIcon = useMemo(function () { return variant === BUTTON_VARIANTS.onlyIcon; }, [
        variant,
    ]);
    var isIconWithTextBig = useMemo(function () { return text && size === 'big' && (LeftIcon || RightIcon); }, [text, size, LeftIcon, RightIcon]);
    var isIconWithTextSmall = useMemo(function () { return text && size === 'small' && (LeftIcon || RightIcon); }, [text, size, LeftIcon, RightIcon]);
    var isTextComponent = useMemo(function () {
        return text &&
            !isOnlyIcon &&
            (variant === 'link' ||
                variant === 'list-item' ||
                variant === 'list-item-active');
    }, [text, isOnlyIcon, variant]);
    var isOrdinaryText = useMemo(function () { return text && !isOnlyIcon; }, [
        text,
        isOnlyIcon,
    ]);
    var buttonTextColor = useMemo(function () { return textColor || 'inherit'; }, [textColor]);
    var linkTextColor = useMemo(function () { return textColor || 'darkPurple'; }, [textColor]);
    return (
    // eslint-disable-next-line
    // @ts-ignore due to a different set of props the type can't be defined properly
    React.createElement(Tag, __assign({ ref: buttonRef, className: cn("" + BLOCK_NAME, (_b = {},
            _b[BLOCK_NAME + "--full-width"] = fullWidth,
            _b[BLOCK_NAME + "--text-center"] = isTextCenter,
            _b[BLOCK_NAME + "--text-left"] = isTextLeft,
            _b[BLOCK_NAME + "--link-breadcrumbs"] = isLink && isBreadcrumbs,
            _b[BLOCK_NAME + "--link-" + linkTextColor] = isLink && Boolean(linkTextColor),
            _b[BLOCK_NAME + "--link-pop-up"] = isLink && isPopUp,
            _b[BLOCK_NAME + "--link-pop-up-dark"] = isLink && isPopUp && isDarkTheme,
            _b[BLOCK_NAME + "--button"] = !isLink,
            _b[BLOCK_NAME + "--" + variant] = Boolean(variant),
            _b[BLOCK_NAME + "--only-icon-small"] = variant === 'only-icon' && size === 'small',
            _b[BLOCK_NAME + "--only-icon-big"] = variant === 'only-icon' && size === 'big',
            _b[BLOCK_NAME + "--" + variant + "-dark"] = Boolean(variant) && isDarkTheme,
            _b[BLOCK_NAME + "--button-" + size] = !isLink && Boolean(size),
            _b[BLOCK_NAME + "--no-text-small"] = !Boolean(text) && size === 'small',
            _b[BLOCK_NAME + "--no-text-big"] = !Boolean(text) && size === 'big',
            _b[BLOCK_NAME + "--icon-text-big"] = isIconWithTextBig,
            _b[BLOCK_NAME + "--icon-text-small"] = isIconWithTextSmall,
            _b[BLOCK_NAME + "--not-full-mobile-width"] = notFullWidthOnMobile,
            _b)), onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseOver: onMouseOver }, tagOptionalProps),
        LeftIcon && (React.createElement("span", { className: cn(BLOCK_NAME + "__icon", (_c = {},
                _c[BLOCK_NAME + "__icon--left-" + size] = Boolean(size),
                _c[BLOCK_NAME + "__icon--no-text"] = !Boolean(text) || isOnlyIcon,
                _c[BLOCK_NAME + "__icon--have-right-icon"] = !Boolean(text) && Boolean(RightIcon),
                _c)) },
            React.createElement(LeftIcon, null))),
        isTextComponent ? (React.createElement(Text, { color: buttonTextColor, isUpperCase: isUpperCase, size: textSize, text: text, textRef: textRef, whiteSpace: textWhiteSpace })) : (isOrdinaryText && (React.createElement("span", { className: cn(BLOCK_NAME + "__text", (_d = {},
                _d[BLOCK_NAME + "__text--uppercase"] = isUpperCase,
                _d[BLOCK_NAME + "__text--white-space-" + textWhiteSpace] = Boolean(textWhiteSpace),
                _d)) }, text))),
        RightIcon && (React.createElement("span", { className: cn(BLOCK_NAME + "__icon", (_e = {},
                _e[BLOCK_NAME + "__icon--right-" + size] = Boolean(size),
                _e[BLOCK_NAME + "__icon--no-text"] = !Boolean(text),
                _e[BLOCK_NAME + "__icon--have-left-icon"] = !Boolean(text) && Boolean(LeftIcon),
                _e)) },
            React.createElement(RightIcon, null))),
        !Boolean(routeName) && !isLink && (React.createElement(ButtonLoader, { isDarkTheme: isDarkTheme, isLoading: isLoading, variant: variant }))));
});
